import Joi from "joi";
import FormValidationResult from "../../../../../common/utils/validation/types/form-validation-result";
import formValidationService from "../../../../../common/utils/validation/form-validation.service";

const validateMaximumDelay = (
  maximumDelay: number | null,
): FormValidationResult => {
  const validationSchema = Joi.number().min(0).max(120);
  return formValidationService.validate(maximumDelay, validationSchema);
};

const orderOptimizerRailyListingMaximumDelayModalValidationService = {
  validateMaximumDelay,
};

export default orderOptimizerRailyListingMaximumDelayModalValidationService;
